<template>
  <div class="limited-award-list-item">
    <div class="award-item-top">
      <div class="top-left">
        <p class="top-title">
          {{ getTaskName(task.pay, task.taskName) }}
        </p>
      </div>
      <div class="top-right">
        <a
          class="top-btn claim-btn"
          href="javascript:;"
          v-if="task.status === 1"
          @click="toGetAward"
          >{{ letter.limitedTimeActivityClaim }}</a
        >
        <a
          class="top-btn claimed-btn"
          href="javascript:;"
          v-if="task.status === 2"
          >{{ letter.limitedTimeActivityClaimed }}</a
        >
        <a
          class="top-btn not-achieve-btn"
          href="javascript:;"
          v-if="task.status === 0"
          >{{ letter.limitedTimeActivityNotAchieve }}</a
        >
      </div>
    </div>
    <p class="award-item-process" v-if="task.limitedPay">
      {{ getTaskProcess() }}
    </p>
    <p class="award-item-process" v-else="task.limitedPay">
      ( {{ task.status === 0 ? 0 : 1 }}/1)
    </p>
    <div class="award-item-list" @click="checkAwardDetail(task.awardDetail)">
      <limited-time-award-list :awardList="task.award" />
    </div>
    <p class="award-item-time" v-if="task.limitedTime === 'weekly'">
      {{ _weeklyTime }}
    </p>
    <p class="award-item-time" v-if="task.limitedTime === 'monthly'">
      {{ _monthlyTime }}
    </p>
  </div>
</template>

<script type="text/javascript">
import LimitedTimeAwardList from '@components/officialStore/activity/LimitedTimeAwardList.vue';
import { mapState } from 'vuex';
import {
  countDownTimeFormat,
  timestampToDateFormat
} from '@utiles/officialStore';
export default {
  name: 'LimitedTimeTaskListItem',
  props: ['task', 'monthlyTime', 'weeklyTime', 'payMonth'],
  mixins: [],
  data() {
    return {};
  },
  computed: {
    ...mapState({
      letter: state => state.letter,
      lang: state => state.lang,
      showCurrency: state => state.showCurrency,
      limitedTimeActivityMonthStart: state =>
        state.event.limitedTimeActivityMonthStart,
      limitedTimeActivityMonthEnd: state =>
        state.event.limitedTimeActivityMonthEnd
    }),
    _weeklyTime() {
      const { days, hours, minutes, seconds } = countDownTimeFormat(
        this.weeklyTime
      );
      return this.letter.limitedTimeActivityTimeLeft
        .replace('${days}', days)
        .replace('${hours}', hours)
        .replace('${minutes}', minutes)
        .replace('${seconds}', seconds);
    },
    _monthlyTime() {
      const { days, hours, minutes, seconds } = countDownTimeFormat(
        this.monthlyTime
      );
      return this.letter.limitedTimeActivityTimeLeft
        .replace('${days}', days)
        .replace('${hours}', hours)
        .replace('${minutes}', minutes)
        .replace('${seconds}', seconds);
    },
    limitedTimeActivityTime() {
      const startDate = timestampToDateFormat(
        this.limitedTimeActivityMonthStart
      );
      const endDate = timestampToDateFormat(this.limitedTimeActivityMonthEnd);
      return this.letter.limitedTimeActivityTime
        .replace('${startDate}', startDate)
        .replace('${endDate}', endDate);
    }
  },
  methods: {
    checkAwardDetail() {
      this.$emit('checkAwardDetail', this.task.awardDetail);
    },
    toGetAward() {
      console.log('toGetAward', this.task);
      this.$emit('toGetAward', this.task);
    },
    getTaskProcess() {
      return this.letter.limitedTimeActivityTaskProcess
        .replace('${curPay}', this.payMonth)
        .replace('${targetPay}', this.task.pay);
    },
    getTaskName() {
      return this.task.taskName
        .replace('${price}', this.task.pay)
        .replace('${currency}', this.showCurrency);
    }
  },
  components: {
    LimitedTimeAwardList
  }
};
</script>

<style lang="scss" scoped>
@import '@assets/scss/officialStore/officialStore.scss';
.limited-award-list-item {
  background-size: cover;
  background-repeat: no-repeat;
  @psetbg ("limited-time-item-bg.png", false, false);
  width: 296px;
  padding: 26px 23px 19px 21px;
  .award-item {
    &-top {
      display: flex;
      justify-content: space-between;

      .top-left {
        .top-title {
          font-size: 18px;
          line-height: 24px;
          color: var(--limited-time-activity-task-title);
          margin-right: 10px;
          flex: 1;
        }
      }

      .top-right {
        display: flex;
        flex-direction: column;
        align-items: end;

        .top-btn {
          font-size: 18px;
          color: var(--limited-time-activity-task-title);
          display: flex;
          justify-content: center;
          align-items: center;

          &.claim-btn {
            background-size: cover;
            background-repeat: no-repeat;
            @psetbg ("limited-time-claim-btn.png");
          }
          &.claimed-btn {
            background-size: cover;
            background-repeat: no-repeat;
            @psetbg ("limited-time-claimed-btn.png");
          }
          &.not-achieve-btn {
            background-size: cover;
            background-repeat: no-repeat;
            @psetbg ("limited-time-not-achieve-btn.png");
          }
        }
      }
    }
    &-process {
      word-break: break-word;
      width: 100%;
      margin-top: 8px;
      font-size: 18px;
      line-height: 24px;
      color: var(--limited-time-activity-task-content);
    }
    &-list {
      margin-top: 13px;
      cursor: pointer;
    }
    &-time {
      margin-top: 8px;
      font-size: 15px;
      color: var(--limited-time-activity-task-content);
    }
  }
}
@media screen and (orientation: landscape) {
  .limited-award-list-item {
    width: 339px;
    padding: 27px 26px 21px 23px;
  }
}
</style>
